<template>
  <v-container style="margin-bottom: 50px">
    <v-row>
      <v-col class="d-none d-lg-flex" cols="12" style="margin-top:100px">
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-container class="login-container" fluid>
          <v-row>
            <v-col lg4></v-col>
            <v-col cols="12" lg="4">
              <v-alert :type="error ? 'error' : 'success'" dismissible v-if="alert">{{ message }}</v-alert>
              <ValidationObserver ref="form" v-slot="{ invalid, validated, passes, validate }">
                <v-card class="pa-2" style="border-top: 3px solid #e74a18" elevation="10">
                  <div class="layout column align-center"
                       v-if="undefined != productLogo && productLogo.trim().length > 0">
                    <img :src="getProductBrandImageUrl()" alt="logo" class="logoStyle"/>
                  </div>
                  <v-card-text class="pb-0">
                    <v-form>
                      <v-alert v-show="show_success_message" dense outlined prominent type="success">
                        <span>{{ $t('msg.successfully_register') }}</span>
                      </v-alert>

                      <v-alert v-show="cloned_user_message" dense outlined prominent type="success">
                        <span>{{ $t('msg.cloned_user') }}</span>
                      </v-alert>

                      <v-alert v-show="show_reset_message" dense outlined prominent type="success">
                        <span>{{ $t('msg.password_changed') }}</span>
                      </v-alert>

                      <ValidationProvider name="username" rules="required" v-slot="{ errors, valid, failedRules }">
                        <v-text-field :error-messages="$translatedErrorMessages(failedRules,'username')"
                                      :label="$t('msg.username')"
                                      :success="valid" append-icon="mdi-account"
                                      autocomplete="new-password"
                                      id="username"
                                      name="username"
                                      required
                                      outlined
                                      dense
                                      type="text" v-model="loginDto.username"
                                      v-on:keyup.enter="passes(login)"></v-text-field>
                      </ValidationProvider>

                      <ValidationProvider name="password" rules="required" v-slot="{ errors, valid, failedRules }">
                        <v-text-field :error-messages="$translatedErrorMessages(failedRules,'password')"
                                      :label="$t('msg.password')"
                                      :success="valid"
                                      append-icon="mdi-lock"
                                      autocomplete="new-password"
                                      id="password"
                                      name="password"
                                      outlined
                                      dense
                                      type="password" v-model="loginDto.password"
                                      v-on:keyup.enter="passes(login)"></v-text-field>
                      </ValidationProvider>
                    </v-form>
                  </v-card-text>

                  <v-spacer></v-spacer>

                  <v-card-text class="pt-0 mt-0 d-flex justify-end">
                    <v-btn text class="pl-0 text-capitalize d-flex justify-end login-page-links">
                      <router-link class="modify-link" to="/forgotPassword"> {{ $t('msg.forgot_password') }}
                      </router-link>
                    </v-btn>
                  </v-card-text>
                  <v-card-text class="pt-0">

                    <v-btn :loading="loading" @click="passes(login)" block color="primary" dark>
                      <v-progress-circular
                        :size="20"
                        :width="3"
                        class="pr-8"
                        color="white"
                        indeterminate
                        v-show="loading"
                      ></v-progress-circular>
                      {{ $t('msg.login') }}
                    </v-btn>

                  </v-card-text>

                  <v-card-actions class="d-flex justify-center">
                    <v-btn text color="primary" class="text-capitalize pr-1 login-page-links">
                      <router-link to="/register"> {{ $t('msg.sign_up') }}</router-link>
                    </v-btn>
                    {{ $t('msg.sign_up_message') }}
                  </v-card-actions>
                  <!--                  <v-card-text class="pt-1 pb-0 text-center">-->
                  <!--                    <p class="black&#45;&#45;text">{{ $t('msg.note')}}</p>-->
                  <!--                  </v-card-text>-->

                  <v-container>
                    <v-row align-h="around">
                      <v-col xs="12" class="text-center login-page-links">
                        <a :href="getPdfFile" target="_blank">
                          {{ $t('msg.user_guide') }}
                        </a>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </ValidationObserver>
            </v-col>
            <v-col lg4></v-col>
          </v-row>
          <div v-if="$i18n.locale === 'en'" class="w-100 mt-3 mt-md-5 d-flex justify-center">
            <div class="text-left pa-3" style="border-radius: 10px; border: 1px solid lightgray;">
              <p class="font-weight-bold text-center"> {{ $t('msg.login_instruction') }} </p>
              <hr/>
              <br/>
              <p class="text--primary"><b>{{ $t('msg.login_instruction_title') }}</b></p>
              <p>☐ <b>{{ $t('msg.login_instruction_1_heading') }}</b> {{ $t('msg.login_instruction_1') }}</p>
              <p>☐ <b>{{ $t('msg.login_instruction_2_heading') }}</b> {{ $t('msg.login_instruction_2') }}</p>
              <p>☐ <b>{{ $t('msg.login_instruction_3_heading') }}</b> {{ $t('msg.login_instruction_3') }}</p>
            </div>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-snackbar color="primary" right top v-model="invalidUserCredentials">
        {{ $t('error.invalid_credentials') }}
      </v-snackbar>
    </v-row>
  </v-container>
</template>
<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {apiUrl, rootUrl} from '../_config'
import {userService} from '../_services'

export default {
  name: 'Login',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    productLogo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      snackbar: false,
      loginDto: {},
      hidePassword: true,
      loading: false,
      result: '',
      showResult: false,
      invalidUserCredentials: false,
      loginModelStatus: true,
      response: {},
      alert: false,
      message: '',
      error: false,
      registrationConfig: {},
      show_success_message: false,
      show_reset_message: false,
      cloned_user_message: false,
      pdfFilePath: '',
      userGuide: ''
    }
  },
  methods: {
    login: function () {
      this.loading = true
      this.$refs.form.validate().then(success => {
        if (!success) {
          return true
        }
        userService.login(this.loginDto).then(response => {
          this.loading = false
          window.location.href = rootUrl() + 'home'
        }).catch(error => {
          this.loading = false
          console.log(error)
          this.invalidUserCredentials = true
        })
      })
    },
    getProductBrandImageUrl: function () {
      return apiUrl() + 'media/logo/' + this.productLogo
    }
  },
  computed: {
    getPdfFile() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/Guide%20for%20Taking%20GFI%20Assessment%20with%20AI%20Proctoring_English_v1.2.pdf';
        case 'to':
          return 'https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/Guide%20for%20Taking%20GFI%20Assessment%20with%20AI%20Proctoring_Tongan_v1.2.pdf';
        default:
          return 'https://nxbas-prod.sgp1.cdn.digitaloceanspaces.com/user-guides/Guide%20for%20Taking%20GFI%20Assessment%20with%20AI%20Proctoring_English_v1.2.pdf';
      }
    }
  },

  mounted() {
    console.log('test reg')
    if (this.$route.query.success) {
      this.show_success_message = true
    } else if (this.$route.query.clonedUser) {
      this.cloned_user_message = true
    } else {
      this.show_success_message = false
    }

    if (this.$route.query.reset) {
      this.show_reset_message = true
    } else {
      this.show_reset_message = false
    }
  }
}
</script>

<style lang="css" scoped>
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

.logoStyle {
  max-width: 250px;
}

.eInsightsLogoStyle {
  width: 316px;
  height: 100px;
}

.v-application a {
  color: #000;
  opacity: .7;
  text-decoration: none;
}

.v-application a:hover {
  opacity: 1;
  text-decoration: underline;
}

.login-container {
  font-size: 16px;
}

.login-page-links a {
  color: #1989E8;
}
</style>
